<mat-menu #filtersMenu="matMenu">
  <ng-container *ngFor="let filter of filters">
    <button
      *ngIf="!!filter.canDisable"
      (click)="onFilterMenuItemClick(filter.id)"
      mat-menu-item
    >
      {{ filter.title.key | translate }}...
    </button>
  </ng-container>
</mat-menu>

<div class="va-filter-chips">
  <mat-icon>filter_list</mat-icon>
  <ng-container *ngFor="let filter of filters">
    <va-filter-chip
      *ngIf="filter.enabled"
      [icon]="filter.icon"
      [canDisable]="filter.canDisable"
      [text]="filter.text"
      [title]="filter.title"
      [id]="filter.id"
      (onClick)="onClickFilter(filter.id)"
      (onDelete)="onDisableFilter(filter.id)"
    ></va-filter-chip>
  </ng-container>
  <ng-container *ngIf="!config || config.canAddAndRemove">
    <button mat-button color="primary" [matMenuTriggerFor]="filtersMenu">
      + {{ 'FILTERS.CHIPS.FILTER' | translate }}
    </button>
    <span>|</span>
    <button mat-button color="secondary" (click)="clearAll()">
      {{ 'FILTERS.CHIPS.CLEAR_ALL' | translate }}
    </button>
  </ng-container>
</div>
